<template>
  <v-dialog :value="filterForm.openModalOrders" max-width="1000" persistent>
    <v-card class="text-center quick-view">
      <v-card-title class="text-sm-left font-weight-bold px-5">
        Thông tin đơn hàng
        <v-divider style="border-color: #d2d2d2" class="mt-3 mb-3"></v-divider>
        <v-spacer />
        <v-icon aria-label="Close" @click="closeModal">mdi-close</v-icon>
      </v-card-title>

        <v-card-text class="pa-4">
          <div>
            <v-row v-for="item in orderList" class="border-item mr-3 ml-8 mb-3">
              <v-col cols="7" class="text-left font-weight-bold">{{ item.code }} - {{ formatPrice(item.totalPrice) }} / {{ item.paymentType}} / {{_.get(item, 'contactStatus.type', '')}}-{{_.get(item, 'contactStatus.name', '')}}</v-col>
              <v-col cols="5" class="text-right font-weight-bold">Sale: {{ item.user && item.user.fullName ? item.user.fullName : '' }}</v-col>

              <v-row style="width: 100%" v-for="product in item.products" class="px-2 pb-1">
                <v-col cols="4" class="pl-0 py-0">
                  <v-row>
                    <v-col cols="3" class="py-0 pr-0 text-right">
                      <v-icon class="pr-1" color="green">mdi-book-open-variant</v-icon>
                    </v-col>
                    <v-col cols="9" class="py-0 text-left">{{ product.name }}</v-col>
                  </v-row>
                </v-col>
                <v-col cols="1" class="pl-0 py-0">{{ product.quantity }}</v-col>
                <v-col cols="2" class="pl-0 py-0">{{ formatPrice(product.price) }}</v-col>
                <v-col cols="3" class="pl-0 py-0">{{ product.childName }}</v-col>
                <v-col cols="2" class="pl-0 py-0">{{ formatDate(item.createdAt) }}</v-col>
              </v-row>

              <v-row style="width: 100%" v-for="combo in item.combos" class="px-2 pb-1">
                <v-col cols="4" class="pl-0 py-0">
                  <v-row>
                    <v-col cols="3" class="py-0 pr-0 text-right">
                      <v-icon class="pr-1" color="green">mdi-book-open-variant</v-icon>
                    </v-col>
                    <v-col cols="9" class="py-0 text-left">{{ combo.name }}</v-col>
                  </v-row>
                </v-col>

                <v-col cols="1" class="pl-0 py-0">{{ combo.quantity }}</v-col>
                <v-col cols="2" class="pl-0 py-0">{{ formatPrice(combo.price) }}</v-col>
                <v-col cols="3" class="pl-0 py-0">{{ combo.childName }}</v-col>
                <v-col cols="2" class="pl-0 py-0">{{ formatDate(item.createdAt) }}</v-col>
              </v-row>

            </v-row>
          </div>
        </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="css" scoped>

</style>

<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';

export default {
  props: {
    orderList: {
      type: Array,
      default: () => []
    },
    filterForm: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    closeModal() {
      this.filterForm.openModalOrders = false;
    }
  }
};
</script>
